let dataProjects = [
    {
        id:1,
        title:"DimaChat",
        description : "This is a real-time chat application built with Laravel, Reverb, React, TailwindCSS, Echo, and Pusher." ,
        img:'./images/DimaChat.png',
        category:"laravel",
        link_github : "https://github.com/Elmahdijaouali/chat-app",
        link_project :"https://github.com/Elmahdijaouali/chat-app"
    },
    {
        id:2,
        title:"E-commerce platform",
        description : "Chtoutka-Service e-commerce platform built with PHP, MySQL, HTML, CSS, and JavaScript." ,
        img:'./images/chtouka-services.png',
        category:"php",
        link_github : "https://github.com/Elmahdijaouali/chtouka_services.git",
        link_project :"https://github.com/Elmahdijaouali/chtouka_services.git"
    },
    {
        id:3,
        title:"Prayer Times",
        description : "A prayer times application that uses an API to display accurate Islamic prayer times based on the user’s location." ,
        img:'./images/prayerTimes.png',
        category:"html",
        link_github : "https://github.com/Elmahdijaouali/prayer-times",
        link_project :"https://elmahdijaouali.github.io/prayer-times/"
    },
    {
        id:4,
        title:"Where in the World",
        description : "A React + Tailwind CSS project that displays country information ." ,
        img:'./images/where_in_the_world.png',
        category:"react",
        link_github : "https://github.com/Elmahdijaouali/where-in-the-world",
        link_project :"https://elmahdijaouali.github.io/where-in-the-world/"
    },
    {
        id:5,
        title:"Dashboard",
        description : "A simple, elegant dashboard built with React JS and Tailwind CSS." ,
        img:'./images/dashboard.png',
        category:"react",
        link_github : "https://github.com/Elmahdijaouali/Simple-Dashboard-by-react-js-",
        link_project :"https://github.com/Elmahdijaouali/Simple-Dashboard-by-react-js-"
    },
    {
        id:6,
        title:"Landing Page",
        description : "A modern responsive gym landing page built using React JS." ,
        img:'./images/landing_page_gym.png',
        category:"react",
        link_github : "https://github.com/Elmahdijaouali/landing-page.git",
        link_project :"https://github.com/Elmahdijaouali/landing-page.git"
    },
    {
        id:7,
        title:"Login & Register UI",
        description : "A stylish login and register user interface built using HTML, CSS, and JavaScript." ,
        img:'./images/login_register_ui.png',
        category:"html",
        link_github : "https://github.com/Elmahdijaouali/login-register-ui",
        link_project :"https://elmahdijaouali.github.io/login-register-ui/"
    }
]

export default dataProjects
